// Transaction Status
const solidStyle = variantColor => {
  switch (variantColor) {
    case 'prelisting':
      return {
        bg: 'tagPrelisting'
      };
    case 'open':
      return {
        bg: 'tagOpen'
      };
    case 'postClosing':
      return {
        bg: 'tagPostClosing'
      };
    case 'closed':
      return {
        bg: 'tagClosed'
      };
    case 'cancelled':
      return {
        bg: 'tagCancelled'
      };
    case 'openInError':
      return {
        bg: 'tagOpenInError',
        color: 'carbon900'
      };
    case 'dismissable':
      return {
        bg: 'tagDismissable'
      };
    case 'complete':
      return {
        bg: 'tagComplete'
      };
    case 'orderProcessing':
      return {
        bg: 'tagOrderProcessing'
      };
    case 'directing':
      return {
        color: 'clay900',
        bg: 'marigold100'
      };
    default:
      return {
        bg: variantColor
      };
  }
};
// To-Do Status
const outlineStyle = variantColor => {
  switch (variantColor) {
    case 'delivered':
      return {
        borderColor: 'tagDelivered',
        color: 'tagDelivered'
      };
    case 'started':
      return {
        borderColor: 'tagStarted',
        color: 'tagStarted'
      };
    case 'submitted':
      return {
        borderColor: 'tagSubmitted',
        color: 'tagSubmitted'
      };
    case 'hold':
      return {
        borderColor: 'tagHold',
        color: 'tagHold'
      };
    case 'recalled':
      return {
        borderColor: 'tagRecalled',
        color: 'tagRecalled'
      };
    case 'newOrder':
      return {
        borderColor: 'tagNewOrder',
        color: 'tagNewOrder'
      };
    case 'inProgress':
      return {
        borderColor: 'tagInProgress',
        color: 'tagInProgress'
      };
    case 'upcoming':
      return {
        borderColor: 'tagUpcoming',
        color: 'tagUpcoming'
      };
    case 'open':
      return {
        borderColor: 'tagOpen',
        color: 'tagOpen'
      };
    default:
      return {
        borderColor: variantColor,
        color: variantColor
      };
  }
};
const getTagStyles = props => {
  const {
    variant,
    variantColor
  } = props;
  switch (variant) {
    case 'outline':
      // @ts-ignore - unclear why error is thrown based on return type
      return {
        ...outlineStyle(variantColor),
        bg: 'white',
        border: '1px solid'
      };
    case 'solid':
    default:
      return {
        border: '1px solid',
        borderColor: 'transparent',
        // @ts-ignore
        color: 'white',
        ...solidStyle(variantColor)
      };
  }
};
const getShapeStyles = props => {
  const {
    shape
  } = props;
  switch (shape) {
    case 'rectangle':
      return {
        borderRadius: 'radiusDefault',
        px: 'space30'
      };
    case 'pill':
    default:
      return {
        // matches figma value
        borderRadius: '10px',
        px: {
          base: 'space30',
          md: 'space40'
        }
      };
  }
};

export { getShapeStyles, getTagStyles, outlineStyle, solidStyle };
